import ApiError from "../../errors/ApiError";
import { UPDATE_ICNEA_PASSWORD_ERROR } from "./error-codes.constants";

export class UpdateIcneaPasswordError extends ApiError {
  constructor() {
    super(UPDATE_ICNEA_PASSWORD_ERROR);
  }
}
